"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// scriptList の個別アイテムのスキーマ
const ENABLE_SCRIPT_TYPE = false;
const ENABLE_ARBITRARY_TAG_FEATURE = false;
exports.default = ({ langId, projectId, segmentId, fixStatus, ignoredReferenceTranslationIds = [], scriptId, additionalData, isTextUpdated, operationMode, isTranslationReadOnly, autoSaveHandler, splitMode, hasTranslation, }) => {
    const additionalDataSchema = Object.keys(additionalData || {}).map((key) => ({
        title: key,
        propertyName: `additionalData.${key}`,
        schema: {
            schemaType: "text",
            readOnly: true,
        },
    }));
    return {
        schemaType: "object",
        style: {
            display: splitMode === "horizontal" ? "block" : "grid",
            columnGap: 40,
            gridTemplateColumns: "repeat(12, 1fr)",
        },
        properties: [
            // {
            //   title: "ID",
            //   propertyName: "scriptId",
            //   style: {
            //     gridColumn: "span 12",
            //   },
            //   schema: {
            //     schemaType: "text",
            //     readOnly: true,
            //   },
            // },
            ...(ENABLE_SCRIPT_TYPE
                ? [
                    {
                        title: "タイプ",
                        propertyName: "scriptType",
                        stacked: true,
                        schema: {
                            schemaType: "text",
                            required: true,
                            autoSaveHandler: autoSaveHandler,
                        },
                    },
                ]
                : []),
            {
                title: "テキスト",
                propertyName: "text",
                stacked: true,
                style: {
                    gridColumn: "span 6",
                },
                schema: {
                    schemaType: "multilineText",
                    count: true,
                    required: true,
                    confirmToEdit: {
                        message: "翻訳前の文章を変更しますか?",
                    },
                    autoSaveHandler: autoSaveHandler,
                    readOnly: operationMode === "translator" || operationMode === "corrector",
                },
            },
            ...(langId
                ? [
                    {
                        title: "翻訳文",
                        propertyName: `translations.${langId}`,
                        stacked: true,
                        style: {
                            gridColumn: "span 6",
                        },
                        tooltip: "翻訳文を入力してください。Ctrl+Enterで翻訳を提案、Tabで提案を確定します。詳しい使い方を見るには、下部の「キー操作一覧」アイコンをクリックしてください。",
                        schema: {
                            schemaType: "copilot",
                            langId,
                            projectId,
                            segmentId,
                            ignoredReferenceTranslationIds,
                            count: true,
                            scriptId,
                            autoSaveHandler: autoSaveHandler,
                            readOnly: isTranslationReadOnly,
                        },
                    },
                    {
                        title: "参照訳に利用",
                        tooltip: "このテキストを参照訳として利用します",
                        propertyName: `translationIgnore.${langId}`,
                        style: {
                            gridColumn: "span 4",
                        },
                        schema: {
                            schemaType: "boolean",
                            invert: true,
                            autoSaveHandler: autoSaveHandler,
                        },
                    },
                ]
                : [
                    {
                        title: "翻訳文",
                        tooltip: "翻訳文を入力してください。Ctrl+Enterで翻訳を提案、Tabで提案を確定します。詳しい使い方を見るには、下部の「キー操作一覧」アイコンをクリックしてください。",
                        style: {
                            gridColumn: "span 6",
                            alignItems: "start",
                        },
                        propertyName: `message`,
                        schema: {
                            schemaType: "message",
                            text: "翻訳先言語を選択してください",
                        },
                    },
                ]),
            {
                title: "単語登録",
                tooltip: "この単語が含まれている文章は、常にこの単語を参照訳として利用します。通常の参照訳は、相対的に一致度の高いものだけが利用されます",
                propertyName: `shouldIncludedIntoSegmentLevelWordTable`,
                style: {
                    gridColumn: "span 4",
                },
                schema: {
                    schemaType: "boolean",
                    autoSaveHandler: autoSaveHandler,
                },
            },
            ...(ENABLE_ARBITRARY_TAG_FEATURE
                ? [
                    {
                        title: "タグ",
                        propertyName: "tags",
                        schema: {
                            schemaType: "array",
                            defaultValue: "",
                            autoSaveHandler: autoSaveHandler,
                            item: {
                                schemaType: "text",
                                autoSaveHandler: autoSaveHandler,
                            },
                            reservedIndexes: 1,
                        },
                    },
                ]
                : []),
            {
                title: "保留",
                propertyName: `tags.0`,
                style: {
                    gridColumn: "span 4",
                },
                schema: {
                    schemaType: "boolean",
                    autoSaveHandler: autoSaveHandler,
                    customValue: "skipped",
                },
            },
            ...(langId
                ? [
                    {
                        title: "ステータス",
                        propertyName: `translationStatus.${langId}`,
                        stacked: true,
                        style: {
                            gridColumn: "span 6",
                        },
                        schema: {
                            schemaType: "selector",
                            options: [
                                {
                                    value: isTextUpdated ? "updated" : null,
                                    title: isTextUpdated ? "更新" : "未着手",
                                },
                                {
                                    value: "translated",
                                    title: "翻訳済み",
                                },
                                {
                                    value: "corrected",
                                    title: "校閲済み",
                                },
                            ],
                            readOnly: fixStatus || !hasTranslation,
                            autoSaveHandler: autoSaveHandler,
                            checkStyle: true,
                        },
                    },
                ]
                : []),
            // ...additionalDataSchema,
        ],
    };
};
